import {connect} from 'react-redux'
import {
  addCardToBoard,
  toggleHint,
  closeHint,
  reset,
  calculateOdds,
  setPlayersCount,
  setRules,
  showHint,
  getWinnerHand,
  setChosenCard,
  removeCard,
  toggleCardActive,
  updateActiveField,
} from '../actions'
import Menu from '../components/menu'
import {getPreparedMenuProps} from "../helpers/menu"

const mapDispatchToProps = (dispatch) => {
  return {
    addCardToBoard: (rank, suit, active) => {
      dispatch(addCardToBoard(rank, suit, active));
    },
    updateActiveField: () => {
      dispatch(updateActiveField());
    },
    closeHint: (type) => {
      dispatch(closeHint(type));
    },
    showHint: (type) => {
      dispatch(showHint(type));
    },
    toggleHint: (type) => {
      dispatch(toggleHint(type))
    },
    reset: () => {
      dispatch(reset())
    },
    calculateOdds: () => {
      dispatch(calculateOdds())
    },
    getWinnerHand: () => {
      dispatch(getWinnerHand())
    },
    setPlayersCount: (id) => {
      dispatch(setPlayersCount(id))
    },
    setRules: (id) => {
      dispatch(setRules(id));
    },
    setChosenCard: (type, id) => {
      dispatch(setChosenCard(type, id))
    },
    removeCard: (rank, suit, type) => {
      dispatch(removeCard(rank, suit, type));
      dispatch(toggleCardActive(rank, suit, true));
    },
  }
};

const mapStateToProps = (state) => {
  return getPreparedMenuProps(state);
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);